import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaPermisos', NominasNominaPermisos)

function NominasNominaPermisos(Permisos) {
  this.get = get

  function get() {
    return Permisos.modulos({
      'cerrar': 'kendu.nominas.detalladoNomina.cerrar',
      'configuracion': 'nominas.nomina.configuracion',
      'movimientos': 'nominas.nomina.movimientos',
      'movimientos.cargar': 'nominas.nomina.movimientos.cargar',
      'deducciones.editar': 'kendu.nominas.detalladoNomina.deducciones.editar',
      'pagos.editar': 'kendu.nominas.detalladoNomina.pagos.editar',
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Permisos.js